module.exports = __webpack_public_path__ + "img/pexels-pixabay-35550.8020419f.jpg";